import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "trustwall_lang";

function getPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
    return "nl";
  });

  const setLang = useCallback((code) => {
    if (translations[code]) {
      localStorage.setItem(STORAGE_KEY, code);
      setLangState(code);
    }
  }, []);

  const t = useCallback(
    (path, fallback) => {
      const value = getPath(translations[lang], path);
      if (value === undefined) {
        const nlValue = getPath(translations.nl, path);
        return nlValue !== undefined ? nlValue : fallback !== undefined ? fallback : path;
      }
      return value;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
